import { priceFormatter } from '@noths/polaris-client-utils';
import { CurrencyCode } from '@noths/polaris-dev-ts-types';

import { PriceModifier } from 'src/types';

interface StrategyProps extends PriceModifier {
  currency: CurrencyCode;
}

const priceModifierStrategy = {
  fixed: ({ currency, prices }: StrategyProps) => prices.find((p) => p.currency === currency),
  percentage: ({ prices, currency }: StrategyProps) => prices.find((p) => p.currency === currency),
};

const getPriceModifierPrice = (currency: CurrencyCode, modifier: PriceModifier) =>
  priceModifierStrategy[modifier.type]({ ...modifier, currency });

export const getPersonalisationAmount = (
  currency: CurrencyCode,
  price: number | PriceModifier | null,
) => {
  if (price == null) {
    return {
      isNegative: false,
      value: 0,
    };
  }

  const priceAmount =
    typeof price === 'number' ? price : getPriceModifierPrice(currency, price)?.amount ?? 0;

  return {
    isNegative: priceAmount < 0,
    value: priceAmount,
  };
};

export const getFormattedPersonalisationAmount = (
  currency: CurrencyCode,
  price: number | PriceModifier | null,
) => {
  const { value, isNegative } = getPersonalisationAmount(currency, price);

  return {
    isNegative,
    value: priceFormatter(currency, value),
  };
};
